import front from "../../assets/demoImages/front.png";
import upperJaw from "../../assets/demoImages/upper-reversed.png";
import lowerJaw from "../../assets/demoImages/lower.png";
import left from "../../assets/demoImages/left.png";
import right from "../../assets/demoImages/right.png";
import face from "../../assets/demoImages/demoImage.jpg";
import upper from "../../assets/demoImages/upper.jpg";

export const generateSteps = (cameraSide = "front") => {
    const isBackCam = cameraSide === "back";

    return [
        {
            title: "Front teeth",
            image: front,
            tips: ["Align the front teeth inside the template", "Keep your teeth slightly open."]
        },
        {
            title: "Left side",
            image: isBackCam ? left : right,
            tips: ["Pull the corner of your mouth as back as possible"],
        },
        {
            title: "Right side",
            image: isBackCam ? right : left,
            tips: ["Pull the corner of your mouth as back as possible"]
        },
        {
            title: "Lower jaw",
            image: lowerJaw,
            tips: ["Open your mouth tilt your head downwards", "Fit your teeth within the template."]
        },
        {
            title: "Upper jaw",
            image: isBackCam ? upper : upperJaw,
            tips: ["Open your mouth tilt your head backwards", "Fit your teeth within the template."]
        },
        {
            title: "Face",
            image: face,
            tips: []
        }
    ];
};
